import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateFormat'
})
@Injectable()
export class DateFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
     return super.transform(value, 'dd.MM.yyyy');
  }
}

@Injectable()
export class DayOfWeekFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
     return super.transform(value, 'EE');
  }
}